import TeamList from "components/Team/TeamsList";


export const TeamsPage = () => <div><TeamList></TeamList></div>;
